/** Up to two initials for the avatar: "Jordan Reyes" -> "JR", "ada@x.com" -> "A". */
export function initials(name: string | null, fallback: string | null): string {
  const source = (name ?? "").trim() || (fallback ?? "").trim();
  if (!source) {
    return "?";
  }
  const words = source.includes("@") ? [source] : source.split(/\s+/);
  const letters = words.length > 1 ? [words[0], words[words.length - 1]] : [words[0]];
  return letters
    .map((word) => word?.charAt(0) ?? "")
    .join("")
    .toUpperCase();
}
